<template>
  <div class="data-center">
    <el-row>
      <div class="chart6-content">
        <div>
          <span style="float: left; display: inline-block;margin-top: 10px;">客户源分布</span>
           <el-date-picker
            v-model="value4"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="data-center-select">
          </el-date-picker>
          <div class="order-calendar">
            <ul>
              <li @click="getDataDay()" v-bind:class="{ active: isOrderD}">本日</li>
              <li @click="getDataWeek()" v-bind:class="{ active: isOrderW}">本周</li>
              <li @click="getDataMonth()" v-bind:class="{ active: isOrderM}">本月</li>
              <li @click="getDataYear()" v-bind:class="{ active: isOrderY}">本年</li>
            </ul>
          </div>
          <el-select v-model="value" placeholder="请选择" class="data-center-date-select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div id="chart6" class="chart6"></div>
      </div>
    </el-row>

    <el-row>
      <div class="chart6-content">
        <div>
          <span style="float: left; display: inline-block;margin-top: 10px;">客户价值分布</span>
           <el-button type="primary" size="small" style="float: right; margin-top: 25px; margin-right: 30px;" @click="dialogVisible = true">
             编辑X轴
           </el-button>
          <div class="customer-value">
            <ul>
              <li @click="getDataDay()" v-bind:class="{ active: isOrderD}">客户价值分</li>
              <li @click="getDataWeek()" v-bind:class="{ active: isOrderW}">资料评分</li>
              <li @click="getDataMonth()" v-bind:class="{ active: isOrderM}">客户活跃度</li>
            </ul>
          </div>
          <el-select v-model="value" placeholder="请选择" class="data-center-date-select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div id="chart7" class="chart6"></div>
      </div>
    </el-row>
    <el-dialog
      title="Y轴设置"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="handleClose">
      <div class="data-dialog-content">
        <el-button type="primary" size="small">客户价值分</el-button>
        <el-button type="primary" size="small">客户资料分</el-button>
        <el-button type="primary" size="small">客户活跃度</el-button>
      </div>
      <div class="data-dialog-content-add">
        <el-button type="primary" size="small" style="float: right; margin-top: 4px;" @click="addLine">添加一行</el-button>
      </div>
       <el-table
        border
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="date"
          label="区间"
          width="80">
        </el-table-column>
        <el-table-column
          prop=""
          label="字段值"
          width="">
           <template slot-scope="scope">
            <div class="">
              <el-input v-model="input" placeholder="" style="width: 40px;"></el-input>
              &nbsp;&nbsp;&nbsp;&nbsp;
              &lt;
              &nbsp;&nbsp;&nbsp;&nbsp;
              客户价值分
              &nbsp;&nbsp;&nbsp;&nbsp;
              &lt;=
              &nbsp;&nbsp;&nbsp;&nbsp;
              <el-input v-model="input" placeholder="" style="width: 40px;"></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-row>
      <div class="chart6-content">
        <div>
          <span style="float: left; display: inline-block;margin-top: 10px;">客户区域分析</span>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" class="customer-attribute">
            <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
          </el-checkbox-group>
          <el-select v-model="value" placeholder="请选择" class="data-center-date-select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-cascader
            size="large"
            :options="optionss"
            v-model="sss"
            class="area-select">
          </el-cascader>
        </div>
        <div id="chart8" class="chart6"></div>
      </div>
    </el-row>
  </div>
</template>
<script>
import { regionData, CodeToText } from 'element-china-area-data'
export default {
  name: 'dataCenter',
  data () {
    return {
      input: '',
      tableData: [
        {
          date: '1',
          name: '王小虎'
        },
        {
          date: '2',
          name: '王小虎'
        },
        {
          date: '3',
          name: '王小虎'
        },
        {
          date: '4',
          name: '王小虎'
        }
      ],
      dialogVisible: false,
      checkAll: false,
      checkedCities: ['上海', '北京'],
      cities: ['上海', '北京', '广州', '深圳'],
      isIndeterminate: true,
      sss: '',
      options: [
        {
          value: '选项1',
          label: '昨日'
        },
        {
          value: '选项2',
          label: '近7日'
        },
        {
          value: '选项3',
          label: '近30日'
        }
      ],
      value: '昨日',
      activeName: 'second',
      value4: '',
      isOrderD: true,
      isOrderW: false,
      isOrderM: false,
      isOrderY: false,
      chart1NameArray: [],
      chart1DataArray: [],
      optionss: regionData
    }
  },
  methods: {
    addLine() {
      this.tableData.push({
        date: '1',
        name: '王小虎'
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    getDataDay() {
      this.isOrderD = true
      this.isOrderW = false
      this.isOrderM = false
      this.isOrderY = false
    },
    getDataWeek() {
      this.isOrderD = false
      this.isOrderW = true
      this.isOrderM = false
      this.isOrderY = false
    },
    getDataMonth() {
      this.isOrderD = false
      this.isOrderW = false
      this.isOrderM = true
      this.isOrderY = false
    },
    getDataYear() {
      this.isOrderD = false
      this.isOrderW = false
      this.isOrderM = false
      this.isOrderY = true
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    chart6() {
      let myChart = this.$echarts.init(document.getElementById('chart6'))
      myChart.setOption({
        title: {
          text: '',
          subtext: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'bar'
        }]
      })
    },
    chart7() {
      let myChart = this.$echarts.init(document.getElementById('chart7'))
      myChart.setOption({
        title: {
          text: '',
          subtext: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'bar'
        }]
      })
    },
    chart8() {
      let myChart = this.$echarts.init(document.getElementById('chart8'))
      myChart.setOption({
        title: {
          text: '',
          subtext: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'bar'
        }]
      })
    }
  },
  mounted() {
    this.chart6()
    this.chart7()
    this.chart8()
  },
  created() {
  },
  components: {
  }
}
</script>

<style scoped>
.chart3 {
  width: 100%;
  height: 200px;
}
.chart1-content {
  margin-top: 10px;
  float: left;
  width: 25%;
  height: 255px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
}
.chart3-content {
  margin-top: 10px;
  float: left;
  width: 30%;
  height: 255px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
}
.chart4-content {
  margin-top: 10px;
  float: left;
  width: 30%;
  height: 255px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
}
.chart5-content {
  margin-top: 10px;
  float: left;
  width: 30%;
  height: 255px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
}
.chart1-content p {
  text-align: left;
}
.data-center-add {
  margin-top: 10px;
  margin-left: 10px;
  padding-left: 10px;
  padding-right: 10px;
  float: left;
  width: 20%;
  background: #fff;
  height: 255px;
}
.data-center-add p {
  text-align: left;
  float: left;
}
.data-center-add-input  {
  margin-top: 10px;
  width: 120px;
}
.customer-count {
  margin-top: 10px;
  width: 100%;
  height: 40px;
}
.customer-count p {
  width: 100%;
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  margin: 25px 10px 0px 0px;
}
.data-center-two {
  width: 100%;
  padding-left: 10px;
  background: #fff;
  margin-top: 10px;
}
.data-center-two p {
  text-align: left;
}
.chart6-content {
  margin-top: 10px;
  float: left;
  width: 100%;
  height: 450px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  padding-bottom: 50px;
}
.chart6 {
  float: left;
  width: 100%;
  height: 100%;
}
.customer-distribute {
  width: 400px;
}
.data-el-menu {
  float: right;
  width: 320px;
  margin-left: 10px;
  margin-top: 10px;
}
.data-center-select {
  float: right;
  margin-top: 20px;
  margin-right: 20px;
  margin-left: 10px;
}
.data-center-date-select {
  float: right;
  margin-top: 20px;
}
.order-calendar {
  width: 650px;
  height: 30px;
  float: right;
}
.customer-value {
  width: 500px;
  height: 30px;
  float: right;
}
.order-calendar ul ,.customer-value ul {
  display: inline-block;
  float: right;
  margin: 0;
  margin-right: 50px;
}
.order-calendar ul li,.customer-value ul li {
  float: left;
  width: auto;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 15px;
  display: inline-block;
  margin-top: 20px;
}
.order-calendar ul li.active,.customer-value ul li.active {
  color: #1890FF;
  border-bottom: 1px solid #1890FF;
}
.area-select {
  margin-top: 20px;
  margin-right: 10px;
  float: right;
}
.customer-attribute {
  float: right;
  margin-top: 30px;
  margin-left: 20px;
  margin-right: 40px;
}
.data-dialog-content {

}
.data-dialog-content-add {
  background: green;
}
</style>
